{
  "dashboard": "Dashboard",
  "courses": "Courses",
  "calendar": "Calendar",
  "classes": "Classes",
  "members": "Members",
  "settings": "Settings",
  "school": {
    "switcherLabel": "Schools",
    "select": "Select school",
    "create": "Create a school"
  },
  "tests": "Tests",
  "homework": "Homework",
  "children": "My children",
  "gradebook": "Gradebook",
  "attendance": "Attendance",
  "myProgress": "My progress",
  "projects": "Projects",
  "library": "Library",
  "chats": "Chats",
  "announcements": "Announcements",
  "notifications": "Notifications",
  "moderation": "Moderation",
  "apiKeys": "API keys",
  "billing": "Billing"
}
